module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('emt-form', {
    ref: "user-form",
    attrs: {
      "resource": _vm.itemresource,
      "items": _vm.items_form,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar Usuario")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed11ab0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-edit-user.vue
// module id = 142
// module chunks = 0